import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CloseIcon from '../../../../../assets/images/close.svg';
import "./HardwareInclusiveModal.css"


function HardwareInclusiveModal({ children, modalHeader, modalState, toggleModal }) {
  const closeBtn = <img src={CloseIcon} className="pointer-cursor" onClick={() => toggleModal()} alt="alert-close" />

  return (
    <>
      <Modal
        isOpen={modalState}
        toggle={() => toggleModal()}
        backdrop={true}
        size="xl"
        className="hardware-inclusive-modal-container"
        centered={true}
      >
        <ModalHeader close={closeBtn}>
          <div className="cp-modal-title">
            {modalHeader}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="cp-modal-content-wrapper">
            {children}
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default HardwareInclusiveModal